module.exports = __webpack_public_path__ + "static/img/promoter_imgtwo.76d4c9e6.jpg";